import { render, staticRenderFns } from "./ChallengeManagerAwards.vue?vue&type=template&id=2cd85240"
import script from "./ChallengeManagerAwards.vue?vue&type=script&lang=js"
export * from "./ChallengeManagerAwards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports